export const translations = {
  ru: {
    nav: {
      home: "Главная",
      business: "Бизнес туры",
      travel: "Путешествия-туры",
      retreat: "Ретрит",
      filming: "Съёмки",
      contacts: "Контакты",
      cta: "Получить программу",
    },
    common: {
      learnMore: "Подробнее",
      send: "Отправить",
      sending: "Отправка...",
      submitSuccess: "Заявка отправлена. Мы свяжемся с вами в ближайшее время.",
      submitError: "Не удалось отправить. Попробуйте ещё раз.",
    },
    form: {
      name: "Имя",
      contact: "Телефон / мессенджер",
      tourType: "Тип тура",
      comment: "Комментарий",
      tourBusiness: "Бизнес / Бенчмарк",
      tourПутешествия: "Путешествия",
      tourРетрит: "Ретрит",
      tourFilming: "Съёмки",
      tourOther: "Другое",
    },
    home: {
      heroOverline: "ПРЕМИАЛЬНЫЕ БИЗНЕС-ТУРЫ · КИТАЙ",
      heroTitle: "Туры в Китай\nпод ключ",
      heroSubtitle:
        "Бизнес, технологии, производство и культура Китая в одном маршруте",
      heroDesc:
        "Организуем бенчмарк-поездки на ведущие предприятия и в технологические компании Китая.",
      ctaProgram: "Получить программу",
      ctaТелеграм: "Телеграм",
      ctaWhatsapp: "Вотсап",

      бенчмаркOverline: "БЕНЧМАРК · 标杆",
      бенчмаркTitle: "Посещение ведущих компаний Китая",
      бенчмаркDesc:
        "Мы организуем деловые визиты для изучения бизнес-процессов, управления, автоматизации, инноваций и корпоративной культуры ведущих компаний Китая.",
      companies: [
        { name: "BYD", desc: "Производство электромобилей и батарей", tag: "Электромобили / Батареи" },
        { name: "Tesla Gigafactory Shanghai", desc: "Автоматизация и инновации", tag: "Автопром" },
        { name: "Tencent", desc: "IT, экосистемы и цифровые-продукты", tag: "Технологии" },
        { name: "Huawei", desc: "Телеком и исследований и разработок-центры", tag: "Телеком" },
        { name: "DJI", desc: "Робототехника и беспилотники", tag: "Робототехника" },
        { name: "Alibaba", desc: "Электронная коммерция и облачные технологии", tag: "Облако" },
      ],

      whoOverline: "01 — КТО МЫ",
      whoTitle: "Команда, которая живёт и работает в Китае",
      whoDesc:
        "Diyatour организует поездки под ключ: маршрут, переговоры, переводчики, трансфер, проживание и сопровождение.",

      whyOverline: "02 — ПОЧЕМУ МЫ",
      whyTitle: "Понимаем китайский рынок изнутри",
      whyItems: [
        "Живём и работаем в Китае",
        "Доступ к фабрикам, выставкам и деловым партнёрам",
        "Опыт организации бизнес-групп",
        "Индивидуальные программы под цель клиента",
        "Переводчики и полное сопровождение",
        "Понимаем китайский рынок изнутри",
      ],

      experienceOverline: "03 — ОПЫТ",
      experienceTitle: "Доверяют крупные команды",
      experienceItems: [
        { num: "100", label: "человек — Альфа-Банк, делегация" },
        { num: "40", label: "человек — Альфа-Банк, бизнес-группа" },
        { num: "10+", label: "съёмочных проектов: RTVI, 808, П. Гительман" },
      ],

      ctaTitle: "Хотите организовать поездку в Китай?",
      ctaDesc:
        "Оставьте заявку — мы подготовим маршрут, программу и формат поездки под вашу цель.",

      heroSlides: [
        {
          city: "SHANGHAI",
          title: "ПОСЕТИТЕ ШАНХАЙ",
          desc: "Финансовая столица Китая, высокие технологии и небоскрёбы Pudong.",
        },
        {
          city: "BEIJING",
          title: "ПОСЕТИТЕ ПЕКИН",
          desc: "Великая стена, Запретный город и технологические-кампусы Чжунгуаньцунь.",
        },
        {
          city: "SHENZHEN",
          title: "ПОСЕТИТЕ ШЭНЬЧЖЭНЬ",
          desc: "Силиконовая долина Китая. DJI, Tencent, Huawei.",
        },
        {
          city: "HANGZHOU",
          title: "ПОСЕТИТЕ ХАНЧЖОУ",
          desc: "Озеро Сиху и штаб-квартира Alibaba.",
        },
        {
          city: "GUANGZHOU",
          title: "ПОСЕТИТЕ ГУАНЧЖОУ",
          desc: "Жемчужина южного Китая. Canton Fair и автопром.",
        },
      ],

      pillars: [
        {
          t: "Бизнес",
          d: "Заводы, выставки и встречи с партнёрами.",
        },
        {
          t: "Технологии",
          d: "Технологии-компании, исследований и разработок-центры, инновации Китая.",
        },
        {
          t: "Культура",
          d: "Кухня, чайные церемонии, неторопливые путешествия и горы.",
        },
      ],
      learnMore: "Подробнее",

      popularOverline: "и получите незабываемые впечатления",
      popularTitle: "ПОПУЛЯРНЫЕ ТУРЫ",
      popularItems: [
        {
          tag: "Тур №1",
          t: "Шанхай · Технологии",
          d: "5 дней — Tesla, Tencent, Pudong",
        },
        {
          tag: "Тур №2",
          t: "Пекин · Культура",
          d: "6 дней — Великая стена, Huawei",
        },
        {
          tag: "Тур №3",
          t: "Шэньчжэнь · Робототехника",
          d: "4 дня — DJI, BYD, Foxconn",
        },
        {
          tag: "Тур №4",
          t: "Ханчжоу · Электронная коммерция",
          d: "3 дня — Alibaba, чайные плантации",
        },
      ],

      inspireOverline: "ИССЛЕДУЙТЕ · 探索",
      inspireTitle: "ПУТЕШЕСТВУЙТЕ\nИ\nВДОХНОВЛЯЙТЕ СВОЮ ЖИЗНЬ",
      inspireDesc:
        "Поездка в Китай — это не только бизнес. Откройте для себя страну, где древняя культура встречается с технологиями будущего.",
      watchVideo: "Смотреть видео",
      inspireVideoUrl: "",
      mapSettings: {
        zoom: 1.24,
        centerX: 105,
        centerY: 35,
        layoutX: 54,
        layoutY: 42,
        layoutSize: 145,
        cityLabelSize: 14,
        cityLabelColor: "#6fd6ff",
        cityMarkerSize: 8,
        cityMarkerColor: "#ff6b35",
      },
    },
    business: {
      overline: "БИЗНЕС · БЕНЧМАРК",
      title: "Бизнес и Бенчмарк-туры в Китай",
      desc:
        "Организуем поездки на заводы, в технологические компании, на выставки и деловые встречи в Китае.",
      heroImage: "",
      blocks: [
        { t: "Посещение производств", d: "Заводы, фабрики, технологические линии" },
        { t: "Визиты в IT и технологические-компании", d: "Tencent, Huawei, Alibaba, DJI и другие" },
        { t: "Изучение бизнес-моделей", d: "Управление, автоматизация, культура" },
        { t: "Переговоры с партнёрами", d: "Подготовка встреч и сопровождение" },
        { t: "Участие в выставках", d: "Canton Fair, CES Asia, АвтоШанхай" },
        { t: "Переводчики и сопровождение", d: "Полная организация на месте" },
      ],
      examplesTitle: "Примеры компаний и направлений",
      examples: [
        "BYD",
        "Tesla Gigafactory Shanghai",
        "Tencent",
        "Huawei",
        "DJI",
        "Alibaba",
        "Электроника",
        "Автопром",
        "Робототехника",
      ],
      cta: "Получить программу бенчмарк-тура",
    },
    travel: {
      overline: "ПУТЕШЕСТВИЯ · 旅行",
      title: "Путешествия по Китаю",
      desc:
        "Индивидуальные и групповые маршруты по главным городам и природным локациям Китая.",
      heroImage: "",
      cities: [
        { name: "Шанхай", en: "Shanghai", desc: "Финансовая столица, небоскрёбы, культура" },
        { name: "Ханчжоу", en: "Hangzhou", desc: "Озеро Сиху, штаб-квартира Alibaba" },
        { name: "Пекин", en: "Beijing", desc: "Великая стена, Запретный город" },
        { name: "Шэньчжэнь", en: "Shenzhen", desc: "Город технологий и стартапов" },
        { name: "Гуанчжоу", en: "Guangzhou", desc: "Производственный центр Юга" },
        { name: "Чжанцзяцзе", en: "Zhangjiajie", desc: "Горы, вдохновившие «Аватар»" },
        { name: "Гуйлинь", en: "Guilin", desc: "Карстовые горы и река Лицзян" },
        { name: "Санья", en: "Sanya", desc: "Тропический курорт на острове Хайнань" },
      ],
      cta: "Подобрать маршрут",
    },
    retreat: {
      overline: "RETREAT · 静心",
      title: "Ретрит в Китае",
      desc:
        "Программы для перезагрузки, восстановления энергии и глубокого знакомства с культурой Китая.",
      blocks: [
        { t: "Чайные церемонии", d: "Юньнань, Фуцзянь, Ханчжоу" },
        { t: "Медитации", d: "Монастыри и горные ретриты" },
        { t: "Природа и горы", d: "Хуаншань, Эмэйшань, Уишань" },
        { t: "Китайская культура", d: "Каллиграфия, ушу, цигун" },
        { t: "Неторопливые путешествия", d: "Размеренный темп, глубокое погружение" },
        { t: "Комфортное сопровождение", d: "Бутик-отели и индивидуальные гиды" },
      ],
      cta: "Получить retreat-программу",
    },
    filming: {
      overline: "ПРОДАКШН · 制作",
      title: "Организация съёмок в Китае",
      desc:
        "Помогаем ТВ-командам, блогерам и продакшенам организовать съёмки в Китае.",
      cases: [
        { title: "RTVI", youtubeUrl: "" },
        { title: "808", youtubeUrl: "" },
        { title: "Pavel Gitelman", youtubeUrl: "" },
        { title: "Production studios", youtubeUrl: "" },
      ],
      blocks: [
        { t: "Поиск локаций", d: "Города, природа, заводы, культурные объекты" },
        { t: "Разрешения и координация", d: "Работа с местными властями" },
        { t: "Переводчики", d: "Профильные переводчики на проекте" },
        { t: "Трансфер", d: "Логистика команды и оборудования" },
        { t: "Локальные герои и эксперты", d: "Подбор спикеров и героев" },
        { t: "Сопровождение съёмочной группы", d: "Полный продакшн-сервис" },
      ],
      cta: "Обсудить съёмочный проект",
    },
    contacts: {
      overline: "КОНТАКТЫ · 联系",
      title: "Свяжитесь с нами",
      desc:
        "Расскажите о цели поездки — мы подготовим программу под ваш запрос.",
      heroImage: "",
      channels: {
        telegram: "Телеграм",
        whatsapp: "Вотсап",
        wechat: "Вичат",
        email: "Эл. почта",
      },
      formTitle: "Оставить заявку",
    },
    footer: {
      tagline: "Премиальные туры в Китай для бизнеса и команд",
      rights: "Все права защищены",
      pages: "Навигация",
      contact: "Контакты",
    },
  },
  en: {
    nav: {
      home: "Home",
      business: "Business",
      travel: "Travel",
      retreat: "Retreat",
      filming: "Production",
      contacts: "Contacts",
      cta: "Request program",
    },
    common: {
      learnMore: "Learn more",
      send: "Send",
      sending: "Sending...",
      submitSuccess: "Request sent. We will contact you shortly.",
      submitError: "Could not send. Please try again.",
    },
    form: {
      name: "Name",
      contact: "Phone / messenger",
      tourType: "Tour type",
      comment: "Comment",
      tourBusiness: "Business / Benchmark",
      tourTravel: "Travel",
      tourRetreat: "Retreat",
      tourFilming: "Production",
      tourOther: "Other",
    },
    home: {
      heroOverline: "PREMIUM BUSINESS TRAVEL · CHINA",
      heroTitle: "China tours,\nturnkey.",
      heroSubtitle:
        "Business, technology, manufacturing and culture of China — in one route",
      heroDesc:
        "Benchmark visits to leading manufacturers and tech companies in China.",
      ctaProgram: "Request program",
      ctaTelegram: "Telegram",
      ctaWhatsapp: "WhatsApp",

      benchmarkOverline: "BENCHMARK · 标杆",
      benchmarkTitle: "Visits to China's leading companies",
      benchmarkDesc:
        "We arrange business visits to study processes, management, automation, innovation and corporate culture of leading Chinese companies.",
      companies: [
        { name: "BYD", desc: "EV and battery manufacturing", tag: "EV / Battery" },
        { name: "Tesla Gigafactory Shanghai", desc: "Automation and innovation", tag: "Auto" },
        { name: "Tencent", desc: "IT, ecosystems and digital products", tag: "Tech" },
        { name: "Huawei", desc: "Telecom and R&D centers", tag: "Telecom" },
        { name: "DJI", desc: "Robotics and drones", tag: "Robotics" },
        { name: "Alibaba", desc: "E-commerce and cloud", tag: "Cloud" },
      ],

      whoOverline: "01 — WHO WE ARE",
      whoTitle: "A team that lives and works in China",
      whoDesc:
        "Diyatour delivers turnkey travel: route, negotiations, interpreters, transfers, accommodation and on-the-ground support.",

      whyOverline: "02 — WHY US",
      whyTitle: "We understand the Chinese market from within",
      whyItems: [
        "We live and work in China",
        "Access to factories, expos and partners",
        "Experience running corporate groups",
        "Custom programs aligned with client goals",
        "Interpreters and full support",
        "Insider understanding of the market",
      ],

      experienceOverline: "03 — TRACK RECORD",
      experienceTitle: "Trusted by major teams",
      experienceItems: [
        { num: "100", label: "people — Alfa-Bank delegation" },
        { num: "40", label: "people — Alfa-Bank business group" },
        { num: "10+", label: "production projects: RTVI, 808, P. Gitelman" },
      ],

      ctaTitle: "Planning a trip to China?",
      ctaDesc:
        "Send a request — we'll prepare a route, program and trip format aligned with your goal.",

      heroSlides: [
        {
          city: "SHANGHAI",
          title: "VISIT SHANGHAI",
          desc: "China's financial capital — hi-tech and Pudong skyline.",
        },
        {
          city: "BEIJING",
          title: "VISIT BEIJING",
          desc: "Great Wall, Forbidden City and Zhongguancun tech park.",
        },
        {
          city: "SHENZHEN",
          title: "VISIT SHENZHEN",
          desc: "Silicon Valley of China. DJI, Tencent, Huawei.",
        },
        {
          city: "HANGZHOU",
          title: "VISIT HANGZHOU",
          desc: "West Lake and Alibaba's HQ.",
        },
        {
          city: "GUANGZHOU",
          title: "VISIT GUANGZHOU",
          desc: "Crown jewel of southern China. Canton Fair and auto industry.",
        },
      ],

      pillars: [
        {
          t: "Business",
          d: "Factories, expos and meetings with partners.",
        },
        {
          t: "Technology",
          d: "Tech companies, R&D centers, China's innovations.",
        },
        {
          t: "Culture",
          d: "Cuisine, tea ceremonies, slow travel and mountains.",
        },
      ],
      learnMore: "Learn more",

      popularOverline: "and get unforgettable impressions",
      popularTitle: "POPULAR TOURS",
      popularItems: [
        { tag: "Tour №1", t: "Shanghai · Tech", d: "5 days — Tesla, Tencent, Pudong" },
        { tag: "Tour №2", t: "Beijing · Culture", d: "6 days — Great Wall, Huawei" },
        { tag: "Tour №3", t: "Shenzhen · Robotics", d: "4 days — DJI, BYD, Foxconn" },
        {
          tag: "Tour №4",
          t: "Hangzhou · E-commerce",
          d: "3 days — Alibaba, tea fields",
        },
      ],

      inspireOverline: "EXPLORE · 探索",
      inspireTitle: "TRAVEL AND\nINSPIRE\nYOUR LIFE",
      inspireDesc:
        "A trip to China is more than business. Discover a country where ancient culture meets the technology of the future.",
      watchVideo: "Watch video",
      inspireVideoUrl: "",
      mapSettings: {
        zoom: 1.24,
        centerX: 105,
        centerY: 35,
        layoutX: 54,
        layoutY: 42,
        layoutSize: 145,
        cityLabelSize: 14,
        cityLabelColor: "#6fd6ff",
        cityMarkerSize: 8,
        cityMarkerColor: "#ff6b35",
      },
    },
    business: {
      overline: "BUSINESS · BENCHMARK",
      title: "Business & Benchmark tours to China",
      desc:
        "Visits to factories, tech companies, expos and business meetings in China.",
      heroImage: "",
      blocks: [
        { t: "Factory visits", d: "Plants, factories, production lines" },
        { t: "Tech & IT companies", d: "Tencent, Huawei, Alibaba, DJI and others" },
        { t: "Business model deep-dives", d: "Management, automation, culture" },
        { t: "Negotiations with partners", d: "Meeting prep and on-site support" },
        { t: "Trade shows", d: "Canton Fair, CES Asia, Auto Shanghai" },
        { t: "Interpreters & support", d: "Full on-site organization" },
      ],
      examplesTitle: "Sample companies and verticals",
      examples: [
        "BYD",
        "Tesla Gigafactory Shanghai",
        "Tencent",
        "Huawei",
        "DJI",
        "Alibaba",
        "Electronics",
        "Automotive",
        "Robotics",
      ],
      cta: "Request a benchmark program",
    },
    travel: {
      overline: "TRAVEL · 旅行",
      title: "Travel across China",
      desc:
        "Custom and group routes across the main cities and natural locations of China.",
      heroImage: "",
      cities: [
        { name: "Shanghai", en: "Shanghai", desc: "Financial capital, skyline, culture" },
        { name: "Hangzhou", en: "Hangzhou", desc: "West Lake, Alibaba HQ" },
        { name: "Beijing", en: "Beijing", desc: "Great Wall, Forbidden City" },
        { name: "Shenzhen", en: "Shenzhen", desc: "Tech & startup capital" },
        { name: "Guangzhou", en: "Guangzhou", desc: "Manufacturing hub of the South" },
        { name: "Zhangjiajie", en: "Zhangjiajie", desc: "Mountains that inspired Avatar" },
        { name: "Guilin", en: "Guilin", desc: "Karst mountains and Li river" },
        { name: "Sanya", en: "Sanya", desc: "Tropical resort on Hainan island" },
      ],
      cta: "Plan a route",
    },
    retreat: {
      overline: "RETREAT · 静心",
      title: "Retreat in China",
      desc:
        "Programs to recharge, recover and immerse yourself in Chinese culture.",
      blocks: [
        { t: "Tea ceremonies", d: "Yunnan, Fujian, Hangzhou" },
        { t: "Meditation", d: "Monasteries and mountain retreats" },
        { t: "Nature & mountains", d: "Huangshan, Emeishan, Wuyishan" },
        { t: "Chinese culture", d: "Calligraphy, wushu, qigong" },
        { t: "Slow travel", d: "Calm pace, deep immersion" },
        { t: "Comfortable support", d: "Boutique hotels and private guides" },
      ],
      cta: "Request a retreat program",
    },
    filming: {
      overline: "PRODUCTION · 制作",
      title: "Filming in China",
      desc:
        "Production support for TV teams, bloggers and studios filming in China.",
      cases: [
        { title: "RTVI", youtubeUrl: "" },
        { title: "808", youtubeUrl: "" },
        { title: "Pavel Gitelman", youtubeUrl: "" },
        { title: "Production studios", youtubeUrl: "" },
      ],
      blocks: [
        { t: "Location scouting", d: "Cities, nature, factories, culture" },
        { t: "Permits & coordination", d: "Working with local authorities" },
        { t: "Interpreters", d: "Specialized interpreters on set" },
        { t: "Transfers", d: "Crew and gear logistics" },
        { t: "Local heroes & experts", d: "Speakers and characters casting" },
        { t: "Crew support", d: "Full production service" },
      ],
      cta: "Discuss a production project",
    },
    contacts: {
      overline: "CONTACTS · 联系",
      title: "Get in touch",
      desc: "Tell us your goal — we'll prepare a program tailored to your brief.",
      heroImage: "",
      channels: {
        telegram: "Telegram",
        whatsapp: "WhatsApp",
        wechat: "WeChat",
        email: "Email",
      },
      formTitle: "Send a request",
    },
    footer: {
      tagline: "Premium China tours for business and teams",
      rights: "All rights reserved",
      pages: "Pages",
      contact: "Contact",
    },
  },
};
